import React from 'react';
import { useTranslation } from 'react-i18next';
import Big from 'big.js';
import { helperMargin, Typography } from '@utex/ui-kit';
import { useExchangeRate } from '../../../../../hooks/exchangeRate';

export const Notice = () => {
  const { t } = useTranslation('byBank');
  const { RUBUSD } = useExchangeRate();

  const rate = RUBUSD ? new Big(1).div(RUBUSD).round(2).valueOf() : null;

  return (
    <>
      <Typography.Paragraph size="M" css={helperMargin({ top: 10 })}>
        {t('Transfers in rubles can be sent only at a bank branch Online banking will not work')}
      </Typography.Paragraph>
      <Typography.Paragraph size="M">
        {t('Enter the amount download and print the receipt and pay at the bank branch')}
      </Typography.Paragraph>
      {rate ? (
        <Typography.Paragraph size="M">
          {t('After replenishment you can exchange rubles at a favorable exchange rate')}:
          <br />
          {` 1$ = ${rate} ₽`}
        </Typography.Paragraph>
      ) : (
        <Typography.Paragraph size="M">
          {t('In the next step, after the replenishment, you can exchange rubles to dollars')}
        </Typography.Paragraph>
      )}
    </>
  );
};
